
import Axios from 'axios';
import { BACKEND_URL } from '../../../../../../core/shared/backend_url';

export const axiosCxpress = Axios.create({
    baseURL: BACKEND_URL,
});